import React from 'react';
import { Button } from '@/components/ui/button';

export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction }) {
  return (
    <div className="rounded-lg border border-dashed border-slate-300 bg-white p-8 sm:p-10 text-center">
      {Icon && <div className="w-12 h-12 rounded-lg bg-slate-100 mx-auto mb-3 flex items-center justify-center"><Icon className="w-6 h-6 text-slate-500" strokeWidth={1.6} /></div>}
      <h3 className="font-heading text-lg font-medium text-slate-900">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</p>}
      {actionLabel && onAction && <Button onClick={onAction} className="mt-4 btn-primary">{actionLabel}</Button>}
    </div>
  );
}
